var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0E0E0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3334 18.41L29.9234 17L24.3334 22.59L18.7434 17L17.3334 18.41L22.9234 24L17.3334 29.59L18.7434 31L24.3334 25.41L29.9234 31L31.3334 29.59L25.7434 24L31.3334 18.41Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose1);
export default __webpack_public_path__ + "static/media/ic_close1.b5fff13c52f82ad7c0f881af7ead5df6.svg";
export { ForwardRef as ReactComponent };